import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Container, Icon } from "semantic-ui-react";

class CreateEvent extends React.Component {
  static propTypes = {
    date: PropTypes.string,
    user: PropTypes.string
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { date, user } = this.props;

    return (
      <div data-component="timelineItem" data-event="activity_created">
        <div className="bullet-pointer">
          <Icon color="grey" size="large" circular name="circle" />
        </div>
        <Container data-component="logDetails">
          <time>{date}</time>{" "}
          <FormattedMessage
            id="activity.timeline.event.create"
            defaultMessage="activity.timeline.event.create"
          />
          <div className="user">{user}</div>
        </Container>
      </div>
    );
  }
}

export default CreateEvent;
